import React from 'react';
import Radium from 'radium';
import { bool } from 'prop-types';
import { UTLabel, UTLoading } from '@widergy/energy-ui';

import { message } from 'utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';
import action1 from './action1.svg';
import action2 from './action2.svg';
import action3 from './action3.svg';
import action4 from './action4.svg';
import ActionBox from './components/ActionBox';

const actions = [
  { image: action1, text: message('Landing:action1') },
  { image: action2, text: message('Landing:action2') },
  { image: action3, text: message('Landing:action3') },
  { image: action4, text: message('Landing:action4') }
];

const AuthFormWrapper = ({ children, loading }) => (
  <div style={stylesJS.container}>
    <div style={stylesJS.lateralPanel}>
      <div style={stylesJS.slide}>
        <div style={stylesJS.slideText}>
          <UTLabel primary className={styles.centered} style={stylesJS.title}>
            {message('Landing:title1')}
          </UTLabel>
          <UTLabel primary extrabold className={styles.centered} style={stylesJS.title}>
            {message('Landing:title2')}
          </UTLabel>
          <UTLabel className={styles.centered}>{message('Landing:subtitle')}</UTLabel>
          <UTLabel primary bold style={stylesJS.textInputSize}>
            {message('Landing:bottomMessage')}
          </UTLabel>
        </div>
      </div>
      <div style={stylesJS.actions}>
        {actions.map(action => (
          <ActionBox key={action.text} icon={action.image} text={action.text} />
        ))}
      </div>
    </div>
    <div style={stylesJS.formContainer}>
      <UTLoading loading={loading}>{children}</UTLoading>
    </div>
  </div>
);

AuthFormWrapper.propTypes = {
  loading: bool
};

export default Radium(AuthFormWrapper);
